<div class="card">
  <h2>已完成但未上傳的測試</h2>

  <table class="styled-table">
    <thead>
      <tr>
        <th>參加者識別碼</th>
        <th>測試序列</th>
        <th>日期</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let progress of allCompletedExperiments">
        <td>{{ progress.participantIdentifier }}</td>
        <td>{{ progress.trialSequenceNumber || 'N/A' }}</td>
        <td>{{ getLocalUpdateTime(progress.updateTimeUTC) }}</td>
        <td>
          <button
            *ngIf="!isAuthenticated || isTokenExpired"
            class="button warn"
            (click)="login()"
          >
            登入後上傳
          </button>
          <button
            *ngIf="isAuthenticated && !isTokenExpired"
            class="button success"
            (click)="goToUploadData(progress.participantIdentifier)"
          >
            上傳測試
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
